/** The usable media area excludes the header, sticky refinements and floating player. */
export function getPreviewViewport(scroller: HTMLElement) {
  const viewport = scroller.getBoundingClientRect()
  const header = Number.parseFloat(getComputedStyle(scroller).getPropertyValue('--header-height')) || 0
  let top = Math.max(viewport.top, header)
  let toolbarOffset = 0
  let bottom = Math.min(viewport.bottom, window.innerHeight)
  for (const toolbar of scroller.querySelectorAll<HTMLElement>('[data-slot="listing-sticky-toolbar"]')) {
    const rect = toolbar.getBoundingClientRect()
    if (rect.width && rect.height && rect.top < bottom && rect.bottom > top) {
      toolbarOffset = Math.max(toolbarOffset, rect.top - top)
      top = rect.bottom
    }
  }
  const player = document.querySelector<HTMLElement>(
    '[data-slot="preview-player-positioner"][data-expanded="false"][data-embedded="false"] [data-slot="preview-player-bar"]'
  )
  if (player) bottom = Math.min(bottom, player.getBoundingClientRect().top)
  return { top: top + 16, bottom: bottom - 16, toolbarOffset }
}
